import { Component } from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {LoadingController, NavController, NavParams, Platform, ViewController} from "ionic-angular";
import {TabsPage} from "../tabs/tabs";
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import {StatusBar} from 'ionic-native';

@Component({
    templateUrl: 'livecasino.html',
    selector: 'live-casino',
})

export class LivecasinoPage {
    private trustedUrl: any;
    private loading: any;

    constructor(private sanitizer: DomSanitizer, public loadingCtrl: LoadingController, private params: NavParams, private nav: NavController, private viewCtrl: ViewController,
                private screenOrientation: ScreenOrientation, public platform: Platform) {
        StatusBar.hide();
        this.loading = loadingCtrl.create({content: ''});
        this.loading.present();
        let getData = params.data;
        let urlLunchGame = "http://hk.oplive.info:8080/?infoUrl=h5/3df1a6&username="+getData.username+"&accessToken="+getData.accessToken;
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlLunchGame);
        /*setTimeout(() => {
            this.platform.ready().then(() => {
                if( !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
                    StatusBar.hide();
                }
            });
        },1000);*/
    }

    webLoad(event) {
        this.loading.dismiss().catch(() => {});
    }

    dismiss() {
        this.nav.push(TabsPage, {selectTab: 1}).then(() => {
            let index = this.viewCtrl.index;
            this.nav.remove(index);
            this.platform.ready().then(() => {
                if( !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
                    StatusBar.show();
                }
            });
        });
    }

    ionViewWillLeave() {
        this.platform.ready().then(() => {
            if( !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
                StatusBar.show();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/livecasino/livecasino.ts